(function() {
  let mostLovedProductsSlider;

  const stopVideo = (section) => {
    const videos = section.querySelectorAll('video');

		if (videos) {
			videos.forEach(video => {
				video.pause();
			});
		}
  }

  const playVideo = (section) => {
    const videos = section.querySelectorAll('video');
		const slides = section.querySelectorAll('.most-loved-products__slider .swiper-slide');

		if (videos.length > 0 && slides.length > 0) {
			slides.forEach(slide => {
				if (slide.querySelector('video')) {
					if (slide.classList.contains('swiper-slide-visible')) 
            slide.querySelector('video').play();
					else 
            slide.querySelector('video').pause();
				}
			});
		}
  }

  const initSlider = () => {
    const mostLovedProductsSliders = document.querySelectorAll('.js-product-slider');

    mostLovedProductsSliders.forEach((slider, index) => {
      mostLovedProductsSlider = new Swiper(slider, {
        slidesPerView: 1,
        effect: 'fade',
        navigation: {
          nextEl: '.most-loved-products__slider-nav .swiper-button-next',
          prevEl: '.most-loved-products__slider-nav .swiper-button-prev',
        },
        breakpoints: {
          990: {
            autoplay: {
              delay: slider.dataset.duration * 1000,
              disableOnInteraction: false
            }
          }
        },
        on: {
          afterInit: function() {
            const bullets = this.el.closest('.most-loved-products__container').querySelectorAll('.most-loved-products__tabs-item');
            const slider = this.el.closest('.most-loved-products__container').querySelector('.most-loved-products__slider');

            this.el.closest('.most-loved-products').addEventListener(slider.closest('.most-loved-products').classList.contains('most-loved-products--static') ? 'mouseover' : 'click', (e) => {
              let target = e.target;

              if (target.classList.contains('most-loved-products__tabs-item')) {
                for (let i = 0; i < bullets.length; i++) {
                  bullets[i].classList.remove('most-loved-products__tabs-item--active');
                }
                target.classList.add('most-loved-products__tabs-item--active');

                if (this.el !== undefined) {
                  this.slideTo(Array.from(bullets).indexOf(e.target));
                }
              }
            });

            if (window.matchMedia("(min-width: 990px)").matches) {
              slider.addEventListener('mouseenter', () => {
                if (this.el !== undefined) {
                  const activeBullet = this.el.closest('.most-loved-products__container').querySelector('.most-loved-products__tabs-item--active span');

                  activeBullet.style.animationPlayState = 'paused';
                  this.autoplay.pause();
                }
              });

              slider.addEventListener('mouseleave', () => {
                if (this.el !== undefined) {
                  const activeBullet = this.el.closest('.most-loved-products__container').querySelector('.most-loved-products__tabs-item--active span');

                  activeBullet.style.animationPlayState = 'running';
                  this.autoplay.resume();
                }
              });
            }

            /* Stop autoplay if section_type = 'static' */
            if (slider.closest('.most-loved-products').classList.contains('most-loved-products--static')) {
              this.autoplay.stop();
            } else {
              this.autoplay.start();
            }
          },
          slideChange: function() {
            const bullets = this.el.closest('.most-loved-products__container').querySelectorAll('.most-loved-products__tabs-item');

            for (let i = 0; i < bullets.length; i++) {
              bullets[i].classList.remove('most-loved-products__tabs-item--active');
            }

            bullets[this.activeIndex].classList.add('most-loved-products__tabs-item--active');

            playVideo(this.el.closest('.most-loved-products'));
          }
        }
      });
    });
  }

  const destroySlider = () => {
    if (mostLovedProductsSlider !== undefined) {
      mostLovedProductsSlider.destroy(true, true);
    }
  };

  const initSection = () => {
    const mostLovedProductsSection = document.querySelectorAll('.most-loved-products-section');

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
					if (entry.isIntersecting) 
						playVideo(entry.target);
					else 
						stopVideo(entry.target);
			})
		});
    
    const sectionResizeObserver = new ResizeObserver((entries) => {
      destroySlider();
      initSlider();
      
      const [entry] = entries;
      playVideo(entry.target);
    });

    destroySlider();
    initSlider();

    mostLovedProductsSection.forEach(section => {
      sectionObserver.observe(section);
      sectionResizeObserver.observe(section);
    });
  }

  document.addEventListener('shopify:section:load', function () {
    initSection();
  });

  initSection();
})();

